import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { Container,  Button } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, USERLIST, USERACTUALIZAR } from '../services/apiConfig';

import { DataGrid } from '@mui/x-data-grid';
import  Cargando  from './utils/Cargando.jsx';
import {  DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'; // Importa los componentes de Material-UI
import axios from 'axios';

function UserList() {
 const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
 
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editedName, setEditedName] = useState('');
  const [editedPerfil, setEditedPerfil] = useState('');



  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'username', headerName: 'Usuario', width: 200 },
    { field: 'email', headerName: 'Email', width: 300 },
    { field: 'request_time', headerName: 'Fecha', width: 250 },
    { field: 'perfil', headerName: 'Perfil', width: 20 },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 250,
      renderCell: (params) => (
        <div>
          <Button onClick={() => handleEdit(params.row)}>Editar</Button>

        </div>
      ),},
    // Agrega más columnas según tus necesidades
  ]; 

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditedName(user.username);
    setEditedPerfil(user.perfil);
    setIsEditDialogOpen(true);
  };

  const handleSaveEdit = () => {
    const updatedUserData = {
      id: selectedUser.id, // Asegúrate de incluir el ID del usuario que estás editando
      name: editedName,
      perfil: editedPerfil,
      // Agrega más campos si es necesario
    };
  
    axios.post(API_BASE_URL + USERACTUALIZAR, updatedUserData)
      .then((response) => {
        console.log('Datos guardados exitosamente:', response.data);
        setIsEditDialogOpen(false); // Cierra el diálogo de edición
        // Puedes agregar lógica adicional aquí, como actualizar la lista de usuarios
      })
      .catch((error) => {
        console.error('Error al guardar los datos:', error);
        // Puedes manejar errores o mostrar un mensaje de error al usuario
      });

      setIsEditDialogOpen(false);
  };

  useEffect(() => {

    /*const loggedIn = sessionStorage.getItem("loggedIn");
    if (!loggedIn) {
      navigate("/login");
    }
*/


    // Realiza la solicitud GET a la API cuando el componente se monta
    axios.get(API_BASE_URL + USERLIST)
      .then((response) => {
        setUsers(response.data); // Almacena los datos en el estado "users"
        setLoading(false); // Cambia el estado de carga a falso

      })
      .catch((error) => {
        console.error('Error al cargar los usuarios', error);
        setLoading(false); // Cambia el estado de carga a falso en caso de error
      });
  }, []); // El segundo argumento [] asegura que esta solicitud se realice solo una vez al montar el componente



  return (
    
    <div>
       <Container>
       
      <MenuInicial></MenuInicial>

      <div className='miDiv'><h2>Usuarios</h2></div>


      <div>
      {loading ? (
        // Muestra un mensaje de carga
        <Cargando></Cargando>
      ) : (
        // Muestra la tabla una vez que los datos se han cargado
        <DataGrid rows={users} columns={columns} />
        
      )}
    </div>


   
      </Container>
      <div style={{ height: '90%', width: '100%' }}>
      <Dialog open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)}>
        <DialogTitle>Editar Usuario</DialogTitle>
        <DialogContent>
         <div className='miDiv'>
          <TextField
            label="Nombre"
            value={editedName}
            onChange={(e) => setEditedName(e.target.value)}
            fullWidth
          />
          </div>
          <div className='miDiv'>
          <TextField
            label="Perfil"
            value={editedPerfil}
            onChange={(e) => setEditedPerfil(e.target.value)}
            fullWidth
          />
        </div>
         


        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveEdit} color="primary">
            Guardar
          </Button>
          <Button onClick={() => setIsEditDialogOpen(false)} color="primary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      </div>

      </div>

  );
}

export default UserList;
